import { __rest, __assign } from 'tslib';
import React__default, { useContext } from 'react';
import { Box } from '../box/Box.js';
import { FlexGridContext } from './FlexGridContext.js';

var Col = function (_a) {
  var _b = _a.size,
    size = _b === void 0 ? 1 : _b,
    children = _a.children,
    rest = __rest(_a, ["size", "children"]);
  var gutter = useContext(FlexGridContext).gutter;
  return React__default.createElement(Box, __assign({
    flex: size,
    marginBottom: gutter,
    marginRight: gutter
  }, rest), children);
};

export { Col };
//# sourceMappingURL=Col.js.map
